import { render, staticRenderFns } from "./PageHeaderPrice.vue?vue&type=template&id=fe483a1e&"
import script from "./PageHeaderPrice.vue?vue&type=script&lang=js&"
export * from "./PageHeaderPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports